import { EntityDrawerProps, FCC, FormDrawer, FormDrawerContent, TextField } from "@dgs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PhoneTypeSelectField } from "../../contacts/selects/PhoneTypeSelectField";
import { IContactPhoneFormState } from "../../shared/types";

export const ContactPhoneDrawer: FCC<EntityDrawerProps<IContactPhoneFormState>> = ({ children, ...props }) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: IContactPhoneFormState) => {
			const errors: { [K in keyof IContactPhoneFormState]?: any } = {};

			if (!values.phoneNumber) {
				errors.phoneNumber = t("Required field");
			}

			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...props}
			validate={validate}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<TextField name="phoneNumber" label={t("Phone number")} type="tel" required />
					<PhoneTypeSelectField name="type" label={t("Type")} />
					{children}
				</FormDrawerContent>
			)}
		/>
	);
};
